import React, { useMemo, useContext } from 'react';
import CodeLayout from './CodeLayout';
import { ChartingCodeContext } from 'pages/Test/lib/chartingCodeContext';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import { grey } from '@mui/material/colors';



const CodeLayoutTypeSelector = ({ template }) => {
	const { tab, setTab } = useContext(ChartingCodeContext);

	const handleTabChange = (e, newTabValue) => {
		setTab(newTabValue);
	};

	const containerWidth = useMemo(() => {
		switch(template.layoutSize) {
			case 'sm':
				return 300;
			case 'md':
				return 500;
			case 'lg':
				return 700;
			default:
				return 500;
		}
	}, [ template.layoutSize ]);

	if(tab !== null) {
		const tabs = template?.tabs ?? [];
		return (
			<Paper sx={{ width: containerWidth, padding: 2 }}>
				<Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 2, backgroundColor: grey[ 200 ] }}>

					<Tabs
						value={tab}
						onChange={handleTabChange}
						variant="scrollable"
						scrollButtons="auto"
					>
						{tabs.map(tab => (<Tab label={tab.label} key={tab.label} />))}
					</Tabs>

				</Box>

				<CodeLayout />
			</Paper>
		);
	}

	return (
		<Paper sx={{ width: containerWidth, padding: 2 }}>
			<CodeLayout />
		</Paper>
	);
};

export default CodeLayoutTypeSelector;
